(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cmj-couture-header"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const menu = event.target.closest('.cmj-couture-mobile-nav[open]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cmj-home-model-catalog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cmj-product-catalog')) {
    customElements.define('cmj-product-catalog', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized || this.dataset.completeCatalog !== 'true') return;
        if (document.readyState === 'loading') {
          this.readyHandler = () => this.initialize();
          document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        if (this.readyHandler) document.removeEventListener('DOMContentLoaded', this.readyHandler);
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        const grid = this.querySelector('[data-cmj-grid]');
        const controls = this.querySelector('[data-cmj-filters]');
        const count = this.querySelector('[data-cmj-count]');
        const empty = this.querySelector('[data-cmj-empty]');
        if (!grid || !controls || !count) return;
        const products = Array.from(grid.querySelectorAll('[data-cmj-product]'));
        const buttons = [];
        const formatter = new Intl.NumberFormat(document.documentElement.lang || undefined);
        for (const link of controls.querySelectorAll('a[data-cmj-category]')) {
          const category = link.dataset.cmjCategory;
          if (category !== 'all' && !products.some(product => product.dataset.cmjCategory === category)) {
            link.hidden = true;
            continue;
          }
          const button = document.createElement('button');
          button.type = 'button';
          button.className = link.className;
          button.textContent = link.textContent;
          button.dataset.cmjCategory = category;
          button.setAttribute('aria-pressed', String(category === 'all'));
          button.setAttribute('aria-controls', grid.id);
          link.replaceWith(button);
          buttons.push(button);
          button.addEventListener('click', () => {
            let visible = 0;
            for (const product of products) {
              product.hidden = category !== 'all' && product.dataset.cmjCategory !== category;
              if (!product.hidden) visible += 1;
            }
            for (const control of buttons) {
              control.setAttribute('aria-pressed', String(control === button));
            }
            const label = visible === 1
              ? this.dataset.oneProduct
              : this.dataset.manyProducts.replace('__COUNT__', formatter.format(visible));
            count.textContent = category === 'all' ? label : `${label} · ${button.textContent.trim()}`;
            if (empty) empty.hidden = visible !== 0;
          });
        }
        this.initialized = true;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
